import { curatedNews } from "./db";

// Simulate a network delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getAllNews = async () => {
  await delay(500); // Simulate 500ms network delay
  const publishedNews = curatedNews.filter(n => n.status === "Published");
  return [...publishedNews].sort((a, b) => {
    const dateA = a.published ? new Date(a.published).getTime() : 0;
    const dateB = b.published ? new Date(b.published).getTime() : 0;
    if (dateB !== dateA) {
      return dateB - dateA;
    }
    return b.id - a.id;
  });
};

export const getNewsBySlug = async (slug) => {
  await delay(500);
  const item = curatedNews.find((n) => n.slug === slug && n.status === "Published");
  if (!item) return null;
  return item;
};

export const getRelatedNews = (currentSlug, limit = 3) => {
  const related = curatedNews.filter((n) => n.slug !== currentSlug && n.status === "Published");
  return related
    .sort((a, b) => {
      const dateA = a.published ? new Date(a.published).getTime() : 0;
      const dateB = b.published ? new Date(b.published).getTime() : 0;
      if (dateB !== dateA) {
        return dateB - dateA;
      }
      return b.id - a.id;
    })
    .slice(0, limit);
};
